import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BaasicFormControls, BaasicButton } from 'core/components';
import { Content } from 'core/layouts';

function FacilityAdditionalContactBulkCreateTemplate({ facilityAdditionalContactBulkCreateView , t}) {
    const {
        contentLoading,
        form,
        componentParams
    } = facilityAdditionalContactBulkCreateView;

    return (
        <React.Fragment>
            <Content loading={contentLoading} >
                <div className="modal__header">
                    <h3 className="modal__header__title">Add contacts</h3>
                </div>
                <div className="modal__body">
                    <div className="form__group">
                        <BasicTextArea field={form.$('contacts')} multiLineEdit={true} />
                    </div>
                </div>
            </Content>
            <div className="modal__footer">
                <BaasicFormControls form={form} onSubmit={form.onSubmit} disabled={form.submitting} label="Save"  className='btn btn--med btn--primary' />  
                <BaasicButton
                     className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => componentParams.modalParams.close()}
                />

            </div>
    </React.Fragment>
    )
}

FacilityAdditionalContactBulkCreateTemplate.propTypes = {
    facilityAdditionalContactBulkCreateView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityAdditionalContactBulkCreateTemplate);
